import React, { useState } from "react";

import { Location } from "history";
import { Prompt, useHistory } from "react-router-dom";

import { UnsavedChangedPromptModalStateProviderProps } from "./types";
import UnsavedChangesPromptModal from "./UnsavedChangesPromptModal";

const StateProvider: React.FC<UnsavedChangedPromptModalStateProviderProps> = ({
  showPrompt = false,
  onSaveClick = () => {},
  children,
}) => {
  const history = useHistory();
  const [navigationPath, setNavigationPath] = useState<Location>();

  const handlePrompt = (path: Location) => {
    setNavigationPath(path);
    return false;
  };

  const redirect = () => navigationPath && history.push(navigationPath);

  const handleSaveClick = () => {
    onSaveClick();
    redirect();
  };

  const handleDiscardClick = () => redirect();

  if (navigationPath) {
    return (
      <UnsavedChangesPromptModal
        onDiscardClick={handleDiscardClick}
        onSaveClick={handleSaveClick}
      >
        {children}
      </UnsavedChangesPromptModal>
    );
  }

  return <Prompt when={showPrompt} message={handlePrompt} />;
};
export default StateProvider;
